import React from 'react'
import { FixedSizeList as List } from 'react-window';

/*
    props:
        items: array of items to render
        height: height of the list in pixels
        width: width of the list in pixels
        itemHeight: height of each item in pixels
        itemGap: gap between each item in pixels
        item: (index) function to render each item
        callback: (index, event) function to call when an item is clicked


    Example:
        <WindowList
            height={800}
            width={600}
            itemHeight={70}
            itemGap={10}
            items={items}
            item={(index, items) => <div>{items[index]}</div>}
            callback={(index, event) => { console.log(index, event) }}
        />
*/

export default function WindowList(props) {
    const [_props, setProps] = React.useState(null)
    
    React.useEffect(() => {
        let defaultProps = {
            height: 400,
            width: 300,
            itemHeight: 70,
            itemGap: 10,
            callback: (index) => { console.log(index) },
        }
        setProps({...defaultProps, ...props})
    }, [])
    
    React.useEffect(() => {
        setProps({..._props, ...props})
    }, [props])
    
    const handleRowClick = (index, event) => {
        _props.callback(index, event)
    }
    
    
    const Row = ({ index, style }) => {
        const [hover, setHover] = React.useState(false)
        const defaultStyle = {
            backgroundColor: hover ? "#2196f3" : "#f7f6f2",
            borderRadius: '5px',
            border: '1px solid #eee',
            transition: 'all .2s ease',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: hover ? "#fff" : "#000",
        }

        return (<div 
        style={{...style, 
            ...defaultStyle,
            ...{
                height: _props.itemHeight,
                width: _props.width - 25,
            }
        }} 
        onMouseEnter={() => { setHover(true) }}
        onMouseLeave={() => { setHover(false) }}
        onClick={(event) => handleRowClick(index, event)}>
            {_props.item(index, _props.items)}
        </div>)
    }
    
    const RList = () => (
        <List
        width={_props.width}
        height={_props.height}
        itemCount={_props.items.length}
        itemSize={_props.itemHeight + _props.itemGap}
        style={{
            overflowX: "hidden",
        }}
        >{Row}</List>
    )


 

    return (
        <div>
            {_props && <RList />}
        </div>
    )
}
